import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import PrivateRoute from './apis/PrivateRoute';
import pushToDataLayer from './apis/GTM';



import AppLayout from './pages/AppLayout';
import Shop from './pages/Shop';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import CheckoutPage from './pages/CheckoutPage';
import ProductSection from './components/drawers/ProductPage';
import ProductInputForm from './components/ProductInputForm';
import OrderConfirmPage from './pages/OrderConfirmPage';
import LoginPage from './pages/LoginPage';





// Admin Pages
import DashboardPage from './adminPages/DashboardPage';
import ProductPage from './adminPages/ProductPage';
import OrderPage from './adminPages/OrderPage';


import AdminAppLayout from './pages/AdminAppLayout';
import { getOrCreateCustomerId } from './apis/HandleCustomerId'

const App = () => {



  useEffect(() => {
    const initializeCustomer = async () => {
      try {
        await getOrCreateCustomerId();
      } catch (error) {
        console.error('Failed to initialize customer:', error);
      }
    };
    initializeCustomer();
  }, []);


  /* ------------------------ GTM Configuration ------------------------ */
  const AnalyticsWrapper = () => {

    const location = useLocation();

    useEffect(() => {
      pushToDataLayer('page_view',
        {
          page_path: location.pathname + location.search,
          page_title: document.title
        },
        {
          external_id: localStorage.getItem('customerId')
        }

      );
    }, [location]);

    return null;
  };
  /* ------------------------ GTM Configuration ------------------------ */


  return (
    <Router>
      <AnalyticsWrapper />
      <Routes>

        <Route path="/" element={<AppLayout />}>
          <Route path="login" element={<LoginPage />} />
          <Route index element={<Shop />} />
          <Route path="shop" element={<Shop />} />
          <Route path="shop/:id/:slug" element={<ProductSection />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="cart" element={<Cart />} />
          <Route path="wishlist" element={<Wishlist />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="create-product" element={<ProductInputForm />} />
          <Route path="confirmed-order" element={<OrderConfirmPage />} />
        </Route>



        <Route path="/admin" element={<PrivateRoute> <AdminAppLayout /></PrivateRoute>}>
          <Route index element={<Navigate to="orders" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="products" element={<ProductPage />} />
          <Route path="orders" element={<OrderPage />} />
        </Route>




      </Routes>
    </Router>

  );
};

export default App;